import './qp-picture-loading.less';

import { QpPictureLoadingDirective } from "./qp-picture-loading.directive";
import { QpPictureLoadDirective } from './qp-picture-load.directive';
import { PictureLoadedState } from './manager/picture-loaded-state';
import { PictureLoadfailState } from './manager/picture-loadfail-state';
import { PictureLoadingState } from './manager/picture-loading-state';

import { ImageMockupRestServiceConfig } from '@modules/product/mockup/rest/image-mockup-rest.config';
import { ImageMockupRestService } from '@modules/product/mockup/rest/image-mockup-rest.service';
import { RestfulAccessorProvider } from '@core/data-access/restful';
import { name as accessor } from "@modules/accessor/accessor.module";

let module_name = "qp-picture-loading"

angular.module(module_name, [accessor])
    .service({
        pictureLoadedState: PictureLoadedState,
        pictureLoadfailState: PictureLoadfailState,
        pictureLoadingState: PictureLoadingState,
        imageMockupRestService: ImageMockupRestService,
    })
    .directive({
        qpPictureLoading: QpPictureLoadDirective
    })
    .config(["$accessorProvider", function ($accessorProvider: RestfulAccessorProvider) {
        $accessorProvider.config(ImageMockupRestServiceConfig);
    }])

// export { qpPictureLoadingModule }
export { module_name }
